import classnames from 'classnames';

import styles from './footer-bar.module.css';

interface Props {
    left?: React.ReactNode;
    center?: React.ReactNode;
    right?: React.ReactNode;
    hasBorder?: boolean;
    absolutePosition?: boolean;
    noPadding?: boolean;
    noMargin?: boolean;
    fitHeight?: boolean;
    hasWhiteBackground?: boolean;
}

export function FooterBar(props: Props) {
    const {left = <div />, center = null, right = <div />} = props;

    const styleName = classnames({
        [styles['footer-bar']]: !props.hasBorder,
        [styles['footer-bar--bordered']]: props.hasBorder,
        [styles['absolute-position']]: props.absolutePosition,
        [styles['no-padding']]: props.noPadding,
        [styles['fit-height']]: props.fitHeight,
        [styles['no-margin']]: props.noMargin,
        [styles['footer-bar--white-bg']]: props.hasWhiteBackground,
    });

    return (
        <div className={styleName}>
            {left}
            {center}
            {right}
        </div>
    );
}
